const $db1f432b457e32b4$var$BASE_URL = "https://app.ticketmaster.com/discovery/v2/events";
const $db1f432b457e32b4$var$API_KEY = "tG7aQ3GCK35UI1b0FVQGBmQ2kSZJ2t4e";
async function $db1f432b457e32b4$export$2f6ec72f51ef1792({ country: country, keyword: keyword, page: page }) {
    const URL = `${$db1f432b457e32b4$var$BASE_URL}.json?apikey=${$db1f432b457e32b4$var$API_KEY}&keyword=${keyword}&countryCode=${country}&page=${page}`;
    const res = await fetch(URL);
    const data = await res.json();
    // totalPages = data.page.totalPages
    // currentPages = data.page.number
    //викликати рендер подіїб, потім видалити return
    //викликати пагінацію
    return data;
}
async function $db1f432b457e32b4$export$989581a3d8305675(id) {
    const res = await fetch(`${$db1f432b457e32b4$var$BASE_URL}/${id}.json?apikey=${$db1f432b457e32b4$var$API_KEY}`);
    const data = await res.json();
    return data;
}


const $7fdb1a51114ea38b$var$list = document.querySelector(".events-list");
function $7fdb1a51114ea38b$export$ff0eb5149c4c561a(events) {
    $7fdb1a51114ea38b$var$list.innerHTML = "";
    const markup = events.map((event)=>{
        return `
        <li class="event" data-id="${event.id}">
          <img class="event-img" src="${event.images[0].url}" alt="${event.name}">
          <h3 class="event-title">${event.name}</h3>
          <p class="event-dates">${event.dates.start.localDate}</p>
          <p class="event-venues">${event._embedded.venues[0].name}</p>
        </li>
      `;
    }).join("");
    $7fdb1a51114ea38b$var$list.innerHTML = markup;
}


const $8fe5817d3edcfe4c$export$e5ad74579c86b003 = [
    [
        "Afghanistan",
        "AF"
    ],
    [
        "\xc5land Islands",
        "AX"
    ],
    [
        "Albania",
        "AL"
    ],
    [
        "Algeria",
        "DZ"
    ],
    [
        "American Samoa",
        "AS"
    ],
    [
        "Andorra",
        "AD"
    ],
    [
        "Angola",
        "AO"
    ],
    [
        "Anguilla",
        "AI"
    ],
    [
        "Antarctica",
        "AQ"
    ],
    [
        "Antigua and Barbuda",
        "AG"
    ],
    [
        "Argentina",
        "AR"
    ],
    [
        "Armenia",
        "AM"
    ],
    [
        "Aruba",
        "AW"
    ],
    [
        "Australia",
        "AU"
    ],
    [
        "Austria",
        "AT"
    ],
    [
        "Azerbaijan",
        "AZ"
    ],
    [
        "Bahamas",
        "BS"
    ],
    [
        "Bahrain",
        "BH"
    ],
    [
        "Bangladesh",
        "BD"
    ],
    [
        "Barbados",
        "BB"
    ],
    [
        "Belarus",
        "BY"
    ],
    [
        "Belgium",
        "BE"
    ],
    [
        "Belize",
        "BZ"
    ],
    [
        "Benin",
        "BJ"
    ],
    [
        "Bermuda",
        "BM"
    ],
    [
        "Bhutan",
        "BT"
    ],
    [
        "Bolivia",
        " Plurinational State of",
        "BO"
    ],
    [
        "Bonaire",
        " Sint Eustatius and Saba",
        "BQ"
    ],
    [
        "Bosnia and Herzegovina",
        "BA"
    ],
    [
        "Botswana",
        "BW"
    ],
    [
        "Bouvet Island",
        "BV"
    ],
    [
        "Brazil",
        "BR"
    ],
    [
        "British Indian Ocean Territory",
        "IO"
    ],
    [
        "Brunei Darussalam",
        "BN"
    ],
    [
        "Bulgaria",
        "BG"
    ],
    [
        "Burkina Faso",
        "BF"
    ],
    [
        "Burundi",
        "BI"
    ],
    [
        "Cabo Verde",
        "CV"
    ],
    [
        "Cambodia",
        "KH"
    ],
    [
        "Cameroon",
        "CM"
    ],
    [
        "Canada",
        "CA"
    ],
    [
        "Cayman Islands",
        "KY"
    ],
    [
        "Central African Republic",
        "CF"
    ],
    [
        "Chad",
        "TD"
    ],
    [
        "Chile",
        "CL"
    ],
    [
        "China",
        "CN"
    ],
    [
        "Christmas Island",
        "CX"
    ],
    [
        "Cocos (Keeling) Islands",
        "CC"
    ],
    [
        "Colombia",
        "CO"
    ],
    [
        "Comoros",
        "KM"
    ],
    [
        "Congo",
        "CG"
    ],
    [
        "Congo",
        " Democratic Republic of the",
        "CD"
    ],
    [
        "Cook Islands",
        "CK"
    ],
    [
        "Costa Rica",
        "CR"
    ],
    [
        "C\xf4te d'Ivoire",
        "CI"
    ],
    [
        "Croatia",
        "HR"
    ],
    [
        "Cuba",
        "CU"
    ],
    [
        "Cura\xe7ao",
        "CW"
    ],
    [
        "Cyprus",
        "CY"
    ],
    [
        "Czechia",
        "CZ"
    ],
    [
        "Denmark",
        "DK"
    ],
    [
        "Djibouti",
        "DJ"
    ],
    [
        "Dominica",
        "DM"
    ],
    [
        "Dominican Republic",
        "DO"
    ],
    [
        "Ecuador",
        "EC"
    ],
    [
        "Egypt",
        "EG"
    ],
    [
        "El Salvador",
        "SV"
    ],
    [
        "Equatorial Guinea",
        "GQ"
    ],
    [
        "Eritrea",
        "ER"
    ],
    [
        "Estonia",
        "EE"
    ],
    [
        "Eswatini",
        "SZ"
    ],
    [
        "Ethiopia",
        "ET"
    ],
    [
        "Falkland Islands (Malvinas)",
        "FK"
    ],
    [
        "Faroe Islands",
        "FO"
    ],
    [
        "Fiji",
        "FJ"
    ],
    [
        "Finland",
        "FI"
    ],
    [
        "France",
        "FR"
    ],
    [
        "French Guiana",
        "GF"
    ],
    [
        "French Polynesia",
        "PF"
    ],
    [
        "French Southern Territories",
        "TF"
    ],
    [
        "Gabon",
        "GA"
    ],
    [
        "Gambia",
        "GM"
    ],
    [
        "Georgia",
        "GE"
    ],
    [
        "Germany",
        "DE"
    ],
    [
        "Ghana",
        "GH"
    ],
    [
        "Gibraltar",
        "GI"
    ],
    [
        "Greece",
        "GR"
    ],
    [
        "Greenland",
        "GL"
    ],
    [
        "Grenada",
        "GD"
    ],
    [
        "Guadeloupe",
        "GP"
    ],
    [
        "Guam",
        "GU"
    ],
    [
        "Guatemala",
        "GT"
    ],
    [
        "Guernsey",
        "GG"
    ],
    [
        "Guinea",
        "GN"
    ],
    [
        "Guinea-Bissau",
        "GW"
    ],
    [
        "Guyana",
        "GY"
    ],
    [
        "Haiti",
        "HT"
    ],
    [
        "Heard Island and McDonald Islands",
        "HM"
    ],
    [
        "Holy See",
        "VA"
    ],
    [
        "Honduras",
        "HN"
    ],
    [
        "Hong Kong",
        "HK"
    ],
    [
        "Hungary",
        "HU"
    ],
    [
        "Iceland",
        "IS"
    ],
    [
        "India",
        "IN"
    ],
    [
        "Indonesia",
        "ID"
    ],
    [
        "Iran",
        " Islamic Republic of",
        "IR"
    ],
    [
        "Iraq",
        "IQ"
    ],
    [
        "Ireland",
        "IE"
    ],
    [
        "Isle of Man",
        "IM"
    ],
    [
        "Israel",
        "IL"
    ],
    [
        "Italy",
        "IT"
    ],
    [
        "Jamaica",
        "JM"
    ],
    [
        "Japan",
        "JP"
    ],
    [
        "Jersey",
        "JE"
    ],
    [
        "Jordan",
        "JO"
    ],
    [
        "Kazakhstan",
        "KZ"
    ],
    [
        "Kenya",
        "KE"
    ],
    [
        "Kiribati",
        "KI"
    ],
    [
        "Korea",
        " Democratic People's Republic of",
        "KP"
    ],
    [
        "Korea",
        " Republic of",
        "KR"
    ],
    [
        "Kuwait",
        "KW"
    ],
    [
        "Kyrgyzstan",
        "KG"
    ],
    [
        "Lao People's Democratic Republic",
        "LA"
    ],
    [
        "Latvia",
        "LV"
    ],
    [
        "Lebanon",
        "LB"
    ],
    [
        "Lesotho",
        "LS"
    ],
    [
        "Liberia",
        "LR"
    ],
    [
        "Libya",
        "LY"
    ],
    [
        "Liechtenstein",
        "LI"
    ],
    [
        "Lithuania",
        "LT"
    ],
    [
        "Luxembourg",
        "LU"
    ],
    [
        "Macao",
        "MO"
    ],
    [
        "Madagascar",
        "MG"
    ],
    [
        "Malawi",
        "MW"
    ],
    [
        "Malaysia",
        "MY"
    ],
    [
        "Maldives",
        "MV"
    ],
    [
        "Mali",
        "ML"
    ],
    [
        "Malta",
        "MT"
    ],
    [
        "Marshall Islands",
        "MH"
    ],
    [
        "Martinique",
        "MQ"
    ],
    [
        "Mauritania",
        "MR"
    ],
    [
        "Mauritius",
        "MU"
    ],
    [
        "Mayotte",
        "YT"
    ],
    [
        "Mexico",
        "MX"
    ],
    [
        "Micronesia",
        " Federated States of",
        "FM"
    ],
    [
        "Moldova",
        " Republic of",
        "MD"
    ],
    [
        "Monaco",
        "MC"
    ],
    [
        "Mongolia",
        "MN"
    ],
    [
        "Montenegro",
        "ME"
    ],
    [
        "Montserrat",
        "MS"
    ],
    [
        "Morocco",
        "MA"
    ],
    [
        "Mozambique",
        "MZ"
    ],
    [
        "Myanmar",
        "MM"
    ],
    [
        "Namibia",
        "NA"
    ],
    [
        "Nauru",
        "NR"
    ],
    [
        "Nepal",
        "NP"
    ],
    [
        "Netherlands",
        " Kingdom of the",
        "NL"
    ],
    [
        "New Caledonia",
        "NC"
    ],
    [
        "New Zealand",
        "NZ"
    ],
    [
        "Nicaragua",
        "NI"
    ],
    [
        "Niger",
        "NE"
    ],
    [
        "Nigeria",
        "NG"
    ],
    [
        "Niue",
        "NU"
    ],
    [
        "Norfolk Island",
        "NF"
    ],
    [
        "North Macedonia",
        "MK"
    ],
    [
        "Northern Mariana Islands",
        "MP"
    ],
    [
        "Norway",
        "NO"
    ],
    [
        "Oman",
        "OM"
    ],
    [
        "Pakistan",
        "PK"
    ],
    [
        "Palau",
        "PW"
    ],
    [
        "Palestine",
        " State of",
        "PS"
    ],
    [
        "Panama",
        "PA"
    ],
    [
        "Papua New Guinea",
        "PG"
    ],
    [
        "Paraguay",
        "PY"
    ],
    [
        "Peru",
        "PE"
    ],
    [
        "Philippines",
        "PH"
    ],
    [
        "Pitcairn",
        "PN"
    ],
    [
        "Poland",
        "PL"
    ],
    [
        "Portugal",
        "PT"
    ],
    [
        "Puerto Rico",
        "PR"
    ],
    [
        "Qatar",
        "QA"
    ],
    [
        "R\xe9union",
        "RE"
    ],
    [
        "Romania",
        "RO"
    ],
    [
        "Russian Federation",
        "RU"
    ],
    [
        "Rwanda",
        "RW"
    ],
    [
        "Saint Barth\xe9lemy",
        "BL"
    ],
    [
        "Saint Helena",
        " Ascension and Tristan da Cunha",
        "SH"
    ],
    [
        "Saint Kitts and Nevis",
        "KN"
    ],
    [
        "Saint Lucia",
        "LC"
    ],
    [
        "Saint Martin (French part)",
        "MF"
    ],
    [
        "Saint Pierre and Miquelon",
        "PM"
    ],
    [
        "Saint Vincent and the Grenadines",
        "VC"
    ],
    [
        "Samoa",
        "WS"
    ],
    [
        "San Marino",
        "SM"
    ],
    [
        "Sao Tome and Principe",
        "ST"
    ],
    [
        "Saudi Arabia",
        "SA"
    ],
    [
        "Senegal",
        "SN"
    ],
    [
        "Serbia",
        "RS"
    ],
    [
        "Seychelles",
        "SC"
    ],
    [
        "Sierra Leone",
        "SL"
    ],
    [
        "Singapore",
        "SG"
    ],
    [
        "Sint Maarten (Dutch part)",
        "SX"
    ],
    [
        "Slovakia",
        "SK"
    ],
    [
        "Slovenia",
        "SI"
    ],
    [
        "Solomon Islands",
        "SB"
    ],
    [
        "Somalia",
        "SO"
    ],
    [
        "South Africa",
        "ZA"
    ],
    [
        "South Georgia and the South Sandwich Islands",
        "GS"
    ],
    [
        "South Sudan",
        "SS"
    ],
    [
        "Spain",
        "ES"
    ],
    [
        "Sri Lanka",
        "LK"
    ],
    [
        "Sudan",
        "SD"
    ],
    [
        "Suriname",
        "SR"
    ],
    [
        "Svalbard and Jan Mayen",
        "SJ"
    ],
    [
        "Sweden",
        "SE"
    ],
    [
        "Switzerland",
        "CH"
    ],
    [
        "Syrian Arab Republic",
        "SY"
    ],
    [
        "Taiwan",
        " Province of China",
        "TW"
    ],
    [
        "Tajikistan",
        "TJ"
    ],
    [
        "Tanzania",
        " United Republic of",
        "TZ"
    ],
    [
        "Thailand",
        "TH"
    ],
    [
        "Timor-Leste",
        "TL"
    ],
    [
        "Togo",
        "TG"
    ],
    [
        "Tokelau",
        "TK"
    ],
    [
        "Tonga",
        "TO"
    ],
    [
        "Trinidad and Tobago",
        "TT"
    ],
    [
        "Tunisia",
        "TN"
    ],
    [
        "T\xfcrkiye",
        "TR"
    ],
    [
        "Turkmenistan",
        "TM"
    ],
    [
        "Turks and Caicos Islands",
        "TC"
    ],
    [
        "Tuvalu",
        "TV"
    ],
    [
        "Uganda",
        "UG"
    ],
    [
        "Ukraine",
        "UA"
    ],
    [
        "United Arab Emirates",
        "AE"
    ],
    [
        "United Kingdom of Great Britain and Northern Ireland",
        "GB"
    ],
    [
        "United States of America",
        "US"
    ],
    [
        "United States Minor Outlying Islands",
        "UM"
    ],
    [
        "Uruguay",
        "UY"
    ],
    [
        "Uzbekistan",
        "UZ"
    ],
    [
        "Vanuatu",
        "VU"
    ],
    [
        "Venezuela",
        " Bolivarian Republic of",
        "VE"
    ],
    [
        "Viet Nam",
        "VN"
    ],
    [
        "Virgin Islands (British)",
        "VG"
    ],
    [
        "Virgin Islands (U.S.)",
        "VI"
    ],
    [
        "Wallis and Futuna",
        "WF"
    ],
    [
        "Western Sahara",
        "EH"
    ],
    [
        "Yemen",
        "YE"
    ],
    [
        "Zambia",
        "ZM"
    ],
    [
        "Zimbabwe",
        "ZW"
    ]
];



const $fa7a60d60ed0fb7b$var$overlay = document.querySelector(".modal-container");
function $fa7a60d60ed0fb7b$export$69bf191433722f78(event) {
    $fa7a60d60ed0fb7b$var$overlay.innerHTML = `
    <div class="modal">
      <div class="modal-wrapper">
      <button id="closeBtn">&times;</button>
        <img class="modal-img" src="${event.images[0].url}" alt="${event.name}">
        <div class="modal-text">
          <h2 class="h2-info">Info</h2>
          <p class="p-info">${event.info}</p>
          <h2 class="h2-when">When</h2>
          <p class="p-data">${event.dates.start.localDate}</p>
          <p class="p-time">${event.dates.start.localTime}</p>
          <h2 class="h2-where">Where</h2>
          <p class="p-where">${event._embedded.venues[0].city.name}</p>
          <p class="modal-venues">${event._embedded.venues[0].name}</p>
          <h2 class="h2-who">Who</h2>
          <p class="p-who">${event.name}</p>
        </div>
      </div>
      <button class="modal-btn">MORE FROM THIS AUTHOR</button>
    </div>
  `;
    $fa7a60d60ed0fb7b$var$overlay.classList.add("open");
    $fa7a60d60ed0fb7b$var$overlay.querySelector("#closeBtn").addEventListener("click", $fa7a60d60ed0fb7b$var$closeModal);
    $fa7a60d60ed0fb7b$var$overlay.addEventListener("click", (e)=>{
        if (e.target === $fa7a60d60ed0fb7b$var$overlay) $fa7a60d60ed0fb7b$var$closeModal();
    });
}
function $fa7a60d60ed0fb7b$var$closeModal() {
    $fa7a60d60ed0fb7b$var$overlay.classList.remove("open");
    $fa7a60d60ed0fb7b$var$overlay.innerHTML = "";
}


let $8f6a480bb40b134f$var$country = "";
let $8f6a480bb40b134f$var$keyword = "";
let $8f6a480bb40b134f$var$page = 0;
const $8f6a480bb40b134f$var$searchInput = document.getElementById('searchInput');
const $8f6a480bb40b134f$var$searchBtn = document.getElementById('searchBtn');
const $8f6a480bb40b134f$var$countryInput = document.getElementById('countryInput');
const $8f6a480bb40b134f$var$dropdown = document.getElementById('countryDropdown');
const $8f6a480bb40b134f$var$arrowBtn = document.getElementById('arrowBtn');
const $8f6a480bb40b134f$var$message = document.getElementById('message');
const $8f6a480bb40b134f$var$list = document.querySelector(".events-list");
function $8f6a480bb40b134f$var$renderDropdown(list) {
    $8f6a480bb40b134f$var$dropdown.innerHTML = list.map(([name, code])=>`<li class="dropdown-item" data-code="${code}" data-name="${name}">${name}</li>`).join("");
}
function $8f6a480bb40b134f$var$openDropdown() {
    $8f6a480bb40b134f$var$renderDropdown((0, $8fe5817d3edcfe4c$export$e5ad74579c86b003));
    $8f6a480bb40b134f$var$dropdown.classList.add('open');
}
function $8f6a480bb40b134f$var$closeDropdown() {
    $8f6a480bb40b134f$var$dropdown.classList.remove("open");
}
$8f6a480bb40b134f$var$arrowBtn.addEventListener('click', (e)=>{
    e.stopPropagation();
    $8f6a480bb40b134f$var$dropdown.classList.contains('open') ? $8f6a480bb40b134f$var$closeDropdown() : $8f6a480bb40b134f$var$openDropdown();
});
$8f6a480bb40b134f$var$countryInput.addEventListener("input", ()=>{
    const query = $8f6a480bb40b134f$var$countryInput.value.toLowerCase();
    const filtered = (0, $8fe5817d3edcfe4c$export$e5ad74579c86b003).filter(([name])=>name.toLowerCase().includes(query));
    $8f6a480bb40b134f$var$renderDropdown(filtered);
    $8f6a480bb40b134f$var$dropdown.classList.add("open");
});
$8f6a480bb40b134f$var$dropdown.addEventListener("mousedown", (e)=>{
    e.preventDefault();
    const item = e.target.closest(".dropdown-item");
    if (!item) return;
    $8f6a480bb40b134f$var$countryInput.value = item.dataset.name;
    $8f6a480bb40b134f$var$country = item.dataset.code;
    $8f6a480bb40b134f$var$closeDropdown();
    $8f6a480bb40b134f$var$init();
});
$8f6a480bb40b134f$var$searchBtn.addEventListener("click", ()=>{
    $8f6a480bb40b134f$var$keyword = $8f6a480bb40b134f$var$searchInput.value.trim();
    $8f6a480bb40b134f$var$page = 0;
    $8f6a480bb40b134f$var$init();
});
document.addEventListener("click", (e)=>{
    if (e.target !== $8f6a480bb40b134f$var$countryInput && e.target !== $8f6a480bb40b134f$var$arrowBtn) $8f6a480bb40b134f$var$closeDropdown();
});
async function $8f6a480bb40b134f$var$init() {
    const data = await (0, $db1f432b457e32b4$export$2f6ec72f51ef1792)({
        country: $8f6a480bb40b134f$var$country,
        keyword: $8f6a480bb40b134f$var$keyword,
        page: $8f6a480bb40b134f$var$page
    });
    if (!data._embedded) {
        (0, $7fdb1a51114ea38b$export$ff0eb5149c4c561a)([]);
        $8f6a480bb40b134f$var$message.textContent = "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E";
        return;
    }
    $8f6a480bb40b134f$var$message.textContent = "";
    const events = data._embedded.events;
    (0, $7fdb1a51114ea38b$export$ff0eb5149c4c561a)(events);
}
$8f6a480bb40b134f$var$init();
$8f6a480bb40b134f$var$list.addEventListener("click", async (e)=>{
    const card = e.target.closest(".event");
    if (!card) return;
    const data = await (0, $db1f432b457e32b4$export$989581a3d8305675)(card.dataset.id);
    (0, $fa7a60d60ed0fb7b$export$69bf191433722f78)(data);
});


//# sourceMappingURL=team-project.c81545c1.js.map
